import { cn } from '@goaltree/ui/lib/utils'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'

import { UpgradeDialog } from '@/components/upgrade-dialog'
import { useIsPro } from '@/hooks/use-is-pro'

export function TrialChip() {
  const { t } = useTranslation()
  const { tier, trial } = useIsPro()
  const [open, setOpen] = useState(false)
  if (tier !== 'trial') return null
  const ending = trial.daysLeft <= 2
  return (
    <>
      <button
        type="button"
        onClick={() => setOpen(true)}
        className={cn(
          'shrink-0 cursor-pointer text-xs font-semibold tabular-nums transition-colors',
          ending ? 'text-primary-text' : 'text-muted-foreground hover:text-foreground',
        )}
      >
        {t(ending ? 'trial.badgeEnding' : 'trial.badge', { count: trial.daysLeft })}
      </button>
      <UpgradeDialog open={open} onOpenChange={setOpen} reason="pro" />
    </>
  )
}
